import { Component, OnInit } from '@angular/core';
import { TaskDto } from 'src/app/tasks/shared/dto/task.dto';
import { TaskService } from 'src/app/tasks/shared/task.service';
import { NotificationService } from 'src/app/shared';
import { ProfileSearchComponentModel } from '../../profile-search-component.model';
import { ProfileService } from 'src/app/profiles/shared/profile.service';

@Component({
  selector: 'wl-create-task-search-action',
  templateUrl: './create-task-search-action.component.html',
  styleUrls: ['./create-task-search-action.component.less'],
    standalone: false
})
export class CreateTaskSearchActionComponent implements OnInit {
  public show: boolean;
  public isSaving: boolean;
  public loading: boolean;
  task: TaskDto;

  private _searchModel: ProfileSearchComponentModel;
  constructor(private _notificationService: NotificationService, private _profileService: ProfileService) {}

  ngOnInit(): void {}

  public open(searchModel: ProfileSearchComponentModel) {
    this.task = {} as TaskDto;
    this.show = true;
    this._searchModel = searchModel;
  }

  save() {
    this.isSaving = true;
    let crudPromise;
    if (!this._searchModel.selectAllProfiles) {
      crudPromise = this._profileService.createProfilesTasks(this._searchModel.selectedProfiles, this.task).then(() => {
        this._notificationService.translateSuccess('common.success');
      });
    } else {
      this._searchModel.searchParams.IgnoreProfiles.push(...this._searchModel.selectedProfiles);
      crudPromise = this._profileService.createProfilesTasksAdvanced(this._searchModel.searchParams, this.task).then(() => {
        this._notificationService.translateSuccess('profiles.search.create-profile-tasks-success');
      });
    }
    crudPromise
      .then(
        () => {
          this.show = false;
        },
        (error) => {
          this._notificationService.httpError(error);
        }
      )
      .finally(() => (this.isSaving = false));
  }
}
